// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

htmx.config.globalViewTransitions = true;

window.Splide = Splide;

document.addEventListener('DOMContentLoaded', function () {
    // Sticky Navbar
    let lastScrollTop = window.scrollY;
    const navbar = document.querySelector('.site-header');

    window.addEventListener('scroll', function() {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll === 0) {
            navbar.classList.remove('scrolling-up');
        } else if (currentScroll > lastScrollTop && currentScroll > navbar.offsetHeight) {
            navbar.classList.remove('scrolling-up');
        } else if (currentScroll < lastScrollTop) {
            navbar.classList.add('scrolling-up');
        }
        lastScrollTop = currentScroll;
    });
});
